import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Grid, TextField, Button, Typography, } from '@mui/material';
import { v4 } from 'uuid';
import { useStore } from '@mcn-platform/models';
import { useForm, Controller } from 'react-hook-form';
const FormField = ({ control, name, label, required, }) => (_jsx(Controller, { name: name, control: control, render: ({ field: { onChange, value, }, }) => (_jsx(TextField, { fullWidth: true, label: label, name: name, onChange: onChange, required: required, value: value, variant: "outlined", InputLabelProps: {
            style: { color: '#000000' },
        } })) }));
const LeadWidget = ({ lead, successMessage, limitToPageWidth, }) => {
    const store = useStore();
    const { currentCustomer } = store;
    const [isChanged, setDisabled] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const { handleSubmit, control, watch } = useForm({
        mode: 'onChange',
    });
    const onSubmit = (data) => {
        setDisabled(false);
        console.log('onSubmit:', {
            data,
        });
        const newLead = store.create('lead', v4(), 'New Lead', {
            organization: store.currentOrganization,
            ...data,
        });
        console.log('data:', {
            organization: store.currentOrganization,
            ...data,
        });
        store.addStub('lead', newLead);
        setShowSuccessMessage(true);
    };
    useEffect(() => {
        const subscription = watch(() => {
            setDisabled(true);
        });
        return () => subscription.unsubscribe();
    }, [currentCustomer, watch]);
    return (_jsx(Box, { sx: {
            width: '100%',
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: _jsxs("form", { autoComplete: "off", onSubmit: handleSubmit(onSubmit), children: [_jsx(Grid, { container: true, spacing: 3, sx: { alignItems: 'center' }, children: lead.filter((field) => (field.display)).map((field) => (_jsxs(React.Fragment, { children: [_jsx(Grid, { item: true, md: 6, sm: 8, xs: 12, children: _jsx(Grid, { item: true, sx: {
                                    // my: 1.5,
                                    }, children: _jsx(FormField, { label: field.label, name: field.key, required: field.required, control: control, value: "" }) }) }), _jsx(Grid, { item: true, md: 2, sx: { display: { xs: 'none', md: 'block' } } })] }, field.key))) }), _jsx(Box, { sx: {
                        display: 'flex',
                        justifyContent: { sm: 'flex-start', xs: 'center' },
                        mt: { sm: 2, xs: 4 },
                    }, children: !showSuccessMessage && (_jsx(Button, { color: "primary", variant: "contained", type: "submit", className: "primary", disabled: !isChanged, children: "Submit" })) }), _jsx(Box, { sx: {
                        display: 'flex',
                        justifyContent: { sm: 'flex-start', xs: 'center' },
                        mt: { sm: 2, xs: 4 },
                    }, children: showSuccessMessage && (_jsx(Typography, { className: "systemPagesMessage", children: successMessage })) })] }) }));
};
LeadWidget.meta = {
    group: 'design',
    name: 'Lead Capture',
    description: 'Displays Lead Capture Form',
    props: [
        {
            key: 'lead',
            name: 'Lead Form',
            type: 'lead',
            description: 'Display the Lead Form',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
        {
            key: 'successMessage',
            name: 'Success Message',
            type: 'text',
            description: 'Text to display for Success Message.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'LeadWidget',
        sort: 100,
        props: {
            successMessage: 'Thank you.',
            limitToPageWidth: true,
            lead: [
                {
                    key: 'firstName',
                    label: 'First Name',
                    display: true,
                    required: true,
                },
                {
                    key: 'lastName',
                    label: 'Last Name',
                    display: true,
                    required: true,
                },
                {
                    key: 'email',
                    label: 'Email Address',
                    display: true,
                    required: true,
                },
                {
                    key: 'company',
                    label: 'Company',
                    display: true,
                    required: true,
                },
                {
                    key: 'phoneNumber',
                    label: 'Phone Number',
                    display: true,
                    required: true,
                },
            ],
        },
    },
};
export default observer(LeadWidget);
//# sourceMappingURL=LeadWidget.js.map